export const EnumNotificationPlacement = {
  Top: 'top',
  Bottom: 'bottom',
  TopLeft: 'topLeft',
  TopRight: 'topRight',
  BottomLeft: 'bottomLeft',
  BottomRight: 'bottomRight',
};
